import _ from 'lodash'

const saveShoppingCart = () => {
	if (typeof localStorage !== 'undefined') {
		localStorage.shoppingCart = JSON.stringify(shoppingCart)
	}
}

const loadShoppingCart = () => {
	try {
		return JSON.parse(typeof localStorage !== 'undefined' && localStorage.shoppingCart)
	} catch(e) {
		console.log('error load shopping cart', e)

		return []
	}
}

const sendEvent = () => {
	if (typeof document !== 'undefined') {
		const evt = new Event("shoppingcart", {"bubbles":true, "cancelable":false})
		document.dispatchEvent(evt)
	}
}

var shoppingCart = []

 setTimeout(() => {
 	shoppingCart = loadShoppingCart()
 	if(! _.isEmpty(shoppingCart)) {
 		sendEvent()
 	}
 }, 100)

export function getShoopingCart() {
	return shoppingCart
}

export function getShoopingCartNumber() {
	return _.size(shoppingCart)
}

export function getShoopingCartOfferNumber(offer_id) {
	return _.size(_.filter(shoppingCart, s => s === offer_id))
}

export function addShoppingCart(offer_id, quantity = 1) {
	if (canAddToShoppingCart()) {
		shoppingCart = shoppingCart.concat(_.fill(Array(quantity), parseInt(offer_id, 10)))
		sendEvent()
		saveShoppingCart()
	}
}

export function removeShoppingCart(offer_id, quantity = 1) {
	_.forEach(_.fill(Array(quantity), parseInt(offer_id, 10)), offer_id => {
		const index = _.indexOf(shoppingCart, offer_id)
	
		if (index > -1) {
			shoppingCart.splice(index, 1)
		}
	})

	sendEvent()
	saveShoppingCart()
}

export function canAddToShoppingCart(nb = 1) {
	return _.size(shoppingCart) + nb <= 20
}

export function clearShoppingCart() {
	shoppingCart = []
	sendEvent()
	saveShoppingCart()
}


// WEBPACK FOOTER //
// ./src/functions/shopping-cart.js